import { IProduct } from '@/creditflowresearch/domain/vo/Product';
import Product from './Product';
import IgcProduct from './entities/IgcProduct';
import HycProduct from './entities/HycProduct';
import LmProduct from './entities/LmProduct';
import AbsProduct from './entities/AbsProduct';

type ProductConstructor = new (data: IProduct) => Product;

class ProductFactory {
  private static readonly entityClassMap = new Map<string, ProductConstructor>([
    [IgcProduct.PRODUCT_ID, IgcProduct],
    [HycProduct.PRODUCT_ID, HycProduct],
    [LmProduct.PRODUCT_ID, LmProduct],
    [AbsProduct.PRODUCT_ID, AbsProduct],
  ]);

  static createFromData(data: IProduct): Product | null {
    const EntityClass = ProductFactory.entityClassMap.get(data.id);

    if (!EntityClass) {
      return null;
    }

    return new EntityClass({
      id: data.id,
      abbreviation: data.abbreviation,
      name: data.name,
      displayName: data.displayName,
      beta: data.beta,
      marketDataName: data.marketDataName,
      mobileAbbreviation: data.mobileAbbreviation,
    });
  }
}

export default ProductFactory;
